"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declareComponentKeys = void 0;
const Reflect_1 = require("tsafe/Reflect");
/** @see <https://docs.i18nifty.dev> */
function declareComponentKeys() {
    return function (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    componentNameAsKey) {
        //NOTE: Just to prevent unused warning.
        componentNameAsKey;
        return {
            "i18n": (0, Reflect_1.Reflect)()
        };
    };
}
exports.declareComponentKeys = declareComponentKeys;
